export default __webpack_public_path__ + "static/media/2.4f194262.jpg";